import styled from 'styled-components';

import errorIcon from 'images/error.svg';

const DeleteButton = styled.button`
	width: 30px;
	height: 30px;
	border: 0;
	background-color: transparent;
	background-image: url(${errorIcon});
	background-position: center;
	background-size: 14px;
	background-repeat: no-repeat;
	cursor: pointer;
`;

export default DeleteButton;



// WEBPACK FOOTER //
// ./src/components/Common/DeleteButton/DeleteButton.js